/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSavingsHomeRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetSavingsHomeResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getSavingsHome = (request: GetSavingsHomeRequest, options?: CashRequestOptions) => post<GetSavingsHomeRequest, GetSavingsHomeResponse>("/2.0/cash/get-savings-home", request, {...options, rejectOnError: true })